import { render } from "./Competing2.vue?vue&type=template&id=36ccc6f6&scoped=true"
import script from "./Competing2.vue?vue&type=script&lang=js"
export * from "./Competing2.vue?vue&type=script&lang=js"

import "./Competing2.vue?vue&type=style&index=0&id=36ccc6f6&scoped=true&lang=less"

import exportComponent from "/Users/Shared/Previously Relocated Items/Security/data/www/solo/CyReport/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ccc6f6"]])

export default __exports__